import { USE_UPLOADS_VERSION_2 } from '@cube3/common/model/schema';
import { uploadsMiddleware as uploadsMiddlewareV1 } from './v1/uploads-middleware';
import { uploadsMiddleware as uploadsMiddlewareV2 } from './v2/uploads-middleware-v2';

/**
 * Upload-Middleware takes files from the action and runs a set of steps
 * required to update the ui and stay compatible with legacy cube upload-server
 *
 */
export const uploadsMiddleware = USE_UPLOADS_VERSION_2
  ? uploadsMiddlewareV2
  : uploadsMiddlewareV1;
